<!-- 审核不通过确认页面 -->
<template>
    <van-popup
        :value="value"
        position="bottom"
        round
        safe-area-inset-bottom
        :close-on-click-overlay="true"
        class="review-rejected-popup"
        @input="$emit('input', $event)"
        @click-overlay="handleDismiss"
        @closed="resetForm"
    >
        <div class="sheet">
            <div class="icon-wrap" aria-hidden="true">
                <span class="icon-mark">!</span>
            </div>
            <p class="room-line">{{ roomLine }}</p>
            <h2 class="title">确认不通过该预约?</h2>
            <p class="desc">
                不通过后将立即取消预约并释放会议室时段，请填写原因供客户查看。
            </p>

            <div class="reason-tags">
                <button
                    v-for="tag in reasonTags"
                    :key="tag"
                    type="button"
                    class="reason-tag"
                    :class="{ active: reason === tag }"
                    @click="selectTag(tag)"
                >{{ tag }}</button>
            </div>

            <div class="field">
                <label class="field-label">不通过原因</label>
                <textarea
                    v-model="reason"
                    class="field-input"
                    rows="3"
                    maxlength="100"
                    placeholder="请填写具体原因"
                />
            </div>

            <button
                class="btn-danger"
                type="button"
                :disabled="!canSubmit || submitting"
                @click="handleConfirm"
            >
                确认不通过
            </button>
            <button class="btn-text" type="button" @click="handleDismiss">
                返回
            </button>
        </div>
    </van-popup>
</template>

<script>

import { Toast } from 'vant'
import { isUnauthorizedError } from '@/tools/utils'
import { getRejectReservationRequest } from '@/request/api'

export default {
    name: 'reviewRejected',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        reservationId: {
            type: [String, Number],
            default: '',
        },
        roomName: {
            type: String,
            default: '',
        },
        floor: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '',
        },
        timeRange: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            reason: '',
            submitting: false,
            reasonTags: [
                '会议室临时不可用',
                '非公司租客',
                '客户计划临时改变',
                '其他核销原因',
            ],
        }
    },
    computed: {
        roomLine() {
            const name = String(this.roomName || '').trim()
            const floor = String(this.floor || '').trim()
            const roomLabel = name && floor ? `${name}(${floor})` : (name || floor)
            const parts = [roomLabel, this.date, this.timeRange].filter(Boolean)
            return parts.join(' · ') || '会议室预约'
        },
        canSubmit() {
            return Boolean(String(this.reason || '').trim())
        },
    },
    methods: {
        selectTag(tag) {
            this.reason = tag
        },
        resetForm() {
            this.reason = ''
        },
        handleConfirm() {
            if (this.submitting) return
            const reason = String(this.reason || '').trim()
            if (!reason) {
                this.$toast && this.$toast('请填写不通过原因')
                return
            }
            const reservationId = this.reservationId
            if (reservationId == null || reservationId === '') {
                this.$toast && this.$toast('预约信息无效')
                return
            }

            this.submitting = true
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0,
            })

            getRejectReservationRequest({ reservationId, reason })
                .then(() => {
                    this.$toast && this.$toast('已标记为不通过')
                    this.$emit('confirm')
                    this.$emit('input', false)
                })
                .catch((err) => {
                    if (isUnauthorizedError(err)) return
                    const msg = (err && (err.message || err.msg)) || '审核不通过失败'
                    this.$toast && this.$toast(msg)
                })
                .finally(() => {
                    this.submitting = false
                    Toast.clear()
                })
        },
        handleDismiss() {
            this.$emit('cancel')
            this.$emit('input', false)
        },
    },
}
</script>

<style scoped>
.review-rejected-popup {
    background: transparent;
}

.sheet {
    padding: 0.48rem 0.4rem calc(0.28rem + env(safe-area-inset-bottom));
    background: #ffffff;
    text-align: center;
    box-sizing: border-box;
}

.icon-wrap {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto 0.28rem;
    border-radius: 0.22rem;
    background: #fdecea;
    color: #ef4444;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-mark {
    font-size: 0.48rem;
    font-weight: 700;
    line-height: 1;
}

.room-line {
    margin: 0 0 0.18rem;
    font-size: 0.24rem;
    line-height: 1.4;
    color: #2b7de9;
    font-weight: 500;
}

.title {
    margin: 0 0 0.16rem;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1.35;
    color: #1e3a5f;
}

.desc {
    margin: 0 auto 0.32rem;
    max-width: 6.2rem;
    font-size: 0.24rem;
    line-height: 1.55;
    color: #8a9bb0;
}

.reason-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.14rem;
    margin-bottom: 0.32rem;
}

.reason-tag {
    padding: 0.12rem 0.2rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.32rem;
    background: #ffffff;
    color: #64748b;
    font-size: 0.22rem;
    line-height: 1.3;
    cursor: pointer;
}

.reason-tag.active {
    border-color: #fca5a5;
    background: #fef2f2;
    color: #ef4444;
}

.field {
    text-align: left;
    margin-bottom: 0.36rem;
}

.field-label {
    display: block;
    margin-bottom: 0.14rem;
    font-size: 0.26rem;
    font-weight: 500;
    color: #1e3a5f;
    line-height: 1.3;
}

.field-input {
    display: block;
    width: 100%;
    min-height: 1.4rem;
    padding: 0.22rem 0.24rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.2rem;
    background: #ffffff;
    color: #1e3a5f;
    font-size: 0.26rem;
    line-height: 1.5;
    resize: none;
    outline: none;
    box-sizing: border-box;
    font-family: inherit;
}

.field-input::placeholder {
    color: #b0bccb;
}

.field-input:focus {
    border-color: #fca5a5;
}

.btn-danger {
    display: block;
    width: 100%;
    height: 0.96rem;
    border: none;
    border-radius: 0.48rem;
    background: #ef5b5b;
    color: #ffffff;
    font-size: 0.32rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 0.12rem 0.28rem rgba(239, 91, 91, 0.28);
}

.btn-danger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

.btn-danger:not(:disabled):active {
    background: #e14a4a;
}

.btn-text {
    display: block;
    width: 100%;
    margin-top: 0.2rem;
    padding: 0.16rem 0;
    border: none;
    background: transparent;
    font-size: 0.28rem;
    color: #8a9bb0;
    line-height: 1.4;
    cursor: pointer;
}

.btn-text:active {
    color: #6b7c91;
}
</style>
